import FetchGetDataWithAuthNEW from "../services/FetchGetDataWithAuthNEW";

export default function FechGetOneReservations(club, idReservation) {

  var url = "/reservation/get_one_reservation/" + club + "/" + idReservation;

  return FetchGetDataWithAuthNEW(url);
}

